import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=7f0046f3&scoped=true&"
import script from "./mainBody.vue?vue&type=script&lang=js&"
export * from "./mainBody.vue?vue&type=script&lang=js&"
import style0 from "./mainBody.vue?vue&type=style&index=0&id=7f0046f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0046f3",
  null
  
)

export default component.exports